// extracted by mini-css-extract-plugin
module.exports = {"root":"CurrentAppOrg_root__15uLs"};